module.exports = __webpack_public_path__ + "static/img/pinduoduo.5a06cbea.png";